const principles = [
  {
    icon: "ri-file-search-line",
    title: "只基于公开信息",
    text: "所有档案均来自可公开检索的资料与公开表述，我们做的是整理与梳理，而不是替谁下结论。",
  },
  {
    icon: "ri-links-line",
    title: "给出完整时间线",
    text: "比起情绪最浓的那一段，我们更愿意把前后经过补全，让读者看到事件是怎么一步步走到这里的。",
  },
  {
    icon: "ri-scales-line",
    title: "区分事实与判断",
    text: "文中会明确标注哪些是公开事实，哪些是我们的观察角度。两者不混在一起，是对读者的基本尊重。",
  },
  {
    icon: "ri-refresh-line",
    title: "接受更正",
    text: "如果后续出现新的公开信息，我们会更新原有档案，并在文中标注修订时间与修订内容。",
  },
];

const voices = [
  {
    text: "第一次看到一个把时间线理得这么清楚的栏目，看完之后自己就能判断，而不是被带着走。",
    name: "长期读者 · 郑",
    role: "产品经理",
  },
  {
    text: "最喜欢的是它不急着给结论。有些内容看完当下没感觉，过两周再想起来反而通了。",
    name: "读者 · 何",
    role: "自由撰稿人",
  },
  {
    text: "行业内幕那一栏我几乎每篇都读，很多套路其实自己遇到过，只是当时说不出来。",
    name: "读者 · 梁",
    role: "创业者",
  },
];

export default function PrincipleSection() {
  return (
    <section aria-labelledby="principle-heading" className="container-page py-14">
      <div className="max-w-2xl">
        <span className="text-xs font-medium tracking-[0.2em] text-primary-600">PRINCIPLES</span>
        <h2 id="principle-heading" className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          我们的内容原则
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600">
          做一个关于“内幕”的栏目，最怕的就是自己也变成情绪的一部分。所以我们给自己定了四条规矩，
          它们决定了每一篇档案的写法。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {principles.map((p) => (
          <div key={p.title} className="rounded-lg border border-background-200 bg-background-100 p-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
              <i className={`${p.icon} text-lg`} aria-hidden="true" />
            </span>
            <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{p.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.text}</p>
          </div>
        ))}
      </div>

      <div className="mt-12 rounded-lg border border-background-200 bg-secondary-100 p-6 md:p-8">
        <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
          <i className="ri-chat-quote-line text-accent-600" aria-hidden="true" />
          读者怎么说
        </h3>
        <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
          {voices.map((v) => (
            <blockquote
              key={v.name}
              className="flex flex-col justify-between rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <p className="text-sm leading-relaxed text-foreground-700">“{v.text}”</p>
              <footer className="mt-4 border-t border-background-200 pt-3">
                <p className="text-sm font-medium text-foreground-900">{v.name}</p>
                <p className="mt-0.5 text-xs text-foreground-500">{v.role}</p>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}